(function () {
  function setTitleFromInput(input) {
    if (!input) return;

    var wrap = input.closest('[data-swatch-wrapper]') || input.closest('.swatch') || document;
    var titleEl = wrap.querySelector('.swatch-title-value') || document.querySelector('.swatch-title-value');
    if (!titleEl) return;

    var label = input.getAttribute('data-swatch-label') || input.value;
    titleEl.textContent = label;
  }

  function init() {
    var checked = document.querySelectorAll('.swatch__input:checked');
    checked.forEach(function (input) { setTitleFromInput(input); });
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('swatch__input')) return;
    setTitleFromInput(input);
  });

  document.addEventListener('click', function (e) {
    var label = e.target.closest('label');
    if (!label) return;
    var forId = label.getAttribute('for');
    if (!forId) return;

    var input = document.getElementById(forId);
    if (input && input.classList.contains('swatch__input')) {
      setTimeout(function () { setTitleFromInput(input); }, 0);
    }
  });

  // If the product form is re-rendered via section rendering, re-init.
  document.addEventListener('shopify:section:load', init);
})();